import { AnimatePresence, motion } from "motion/react";
import type { SlideDef } from "./types";

const variants = {
  enter: (d: 1 | -1) => ({
    opacity: 0,
    x: d * 64,
    scale: 0.98,
    filter: "blur(8px)",
  }),
  center: { opacity: 1, x: 0, scale: 1, filter: "blur(0px)" },
  exit: (d: 1 | -1) => ({
    opacity: 0,
    x: d * -64,
    scale: 0.98,
    filter: "blur(8px)",
  }),
};

interface SlideViewportProps {
  slide: SlideDef;
  direction: 1 | -1;
  overview: boolean;
}

export function SlideViewport({ slide, direction, overview }: SlideViewportProps) {
  const Component = slide.component;
  return (
    <AnimatePresence mode="popLayout" custom={direction} initial={false}>
      <motion.div
        key={slide.id}
        custom={direction}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
        transition={{ duration: 0.45, ease: [0.32, 0.72, 0, 1] }}
        className="absolute inset-0"
      >
        <Component active={!overview} />
      </motion.div>
    </AnimatePresence>
  );
}
